var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertCloseButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.2827 5.21677C5.12649 5.06056 4.87322 5.06056 4.71701 5.21677C4.5608 5.37298 4.5608 5.62624 4.71701 5.78245L9.43423 10.4997L4.71714 15.2168C4.56093 15.373 4.56093 15.6262 4.71714 15.7825C4.87335 15.9387 5.12662 15.9387 5.28283 15.7825L9.99992 11.0654L14.717 15.7825C14.8732 15.9387 15.1265 15.9387 15.2827 15.7825C15.4389 15.6262 15.4389 15.373 15.2827 15.2168L10.5656 10.4997L15.2828 5.78245C15.439 5.62624 15.439 5.37298 15.2828 5.21677C15.1266 5.06056 14.8734 5.06056 14.7171 5.21677L9.99992 9.93399L5.2827 5.21677Z",
    fill: "#5B5C5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertCloseButton);
export default __webpack_public_path__ + "static/media/AlertCloseButton.69d2d535930b3ad3be5a391d28ae9373.svg";
export { ForwardRef as ReactComponent };